import get from "lodash/get";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import StatCard from "../../../parts/cards/StatCard";
import GymMembersTable from "./components/GymMembersTable";

const GymMembers = ({ activeMembers, statsData, csvString }) => {
  const { t } = useTranslation("coaching-portal");
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });
  const [search, setSearch] = useState("");

  const handleSort = ({ target }, direction = "ascending") => {
    setSortConfig({ key: target.value, direction });
  };

  const sortedMembers = useMemo(() => {
    let filtered = [...activeMembers];

    if (search) {
      const term = search.toLowerCase().trim();
      filtered = filtered.filter(
        (member) =>
          String(member.name).toLowerCase().includes(term) ||
          String(member.email).toLowerCase().includes(term) ||
          String(member.externalId || "")
            .toLowerCase()
            .includes(term) ||
          String(member._id || "")
            .toLowerCase()
            .includes(term)
      );
    }

    if (sortConfig) {
      filtered.sort((a, b) => {
        const aVal = get(a, sortConfig.key);
        const bVal = get(b, sortConfig.key);
        if (aVal < bVal) return sortConfig.direction === "ascending" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
      });
    }

    return filtered;
  }, [activeMembers, sortConfig, search]);

  return (
    <main className="subscribers-list">
      <header className="stat-cards">
        <StatCard
          title={t("gymMembers.totalMembersCardTitle")}
          tooltipText={t("gymMembers.totalMembersTooltip")}
          current={statsData.totalMembers}
          previous={statsData.previousMonthCount}
          sparklineData={statsData.chartData.totalMembersArray}
          sparklineLabels={statsData.chartData.monthsArray}
        />
      </header>

      <GymMembersTable
        members={sortedMembers}
        sortConfig={sortConfig}
        handleSort={handleSort}
        csvString={csvString}
        search={search}
        setSearch={setSearch}
      />
    </main>
  );
};

export default GymMembers;
